import ImagesChatPopup from './ImagesChatPopup';

export default ImagesChatPopup;
